module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-34-9c2647a677c7ccc1a8c8e5cd8c84fa3d.jpg";